import React, { useState, useEffect } from 'react';
import { Translation } from 'react-i18next';
import { Typography, Input, Button } from 'antd';
import { withRouter } from 'react-router-dom';
import Logger from '../../../../../lib/Logger';
import { PlusOutlined } from '@ant-design/icons';
import { pathTo } from '../../../Routes';
import useDebounce from '../../../elements/components/useDebounce';
import QueryString from '../../../../../lib/QueryString';
import { mixpanelEventsEnum } from '../../../../../lib/Mixpanel';

const { Title } = Typography;

const CognitoFormAdminHeaderScreen = ({
  showForm,
  history,
  trackerActions,
  ...props
}) => {
  const [query, setQuery] = useState('');
  const debouncedQuery = useDebounce(query, 1000);
  let params = QueryString.parse(history.location.search);

  const defaultSearch = 'search' in params ? params['search'] : null;
  const [search, setSearch] = useState(defaultSearch);

  const onSearch = (e) => {
    if (e.target.value === '') {
      let path = props.location.pathname;
      delete params['search'];
      history.push(QueryString.append(path, params));
    }

    setQuery(e.target.value);
    setSearch(e.target.value);
  };

  useEffect(() => {
    setSearch(defaultSearch ?? '');
  }, [defaultSearch]);

  useEffect(() => {
    if (debouncedQuery.trim() === '') {
      return;
    } else {
      if (debouncedQuery === search) {
        delete params['search'];
        params['search'] = debouncedQuery;

        const path = pathTo('CognitoFormsAdminScreen', {
          page: 1,
        });
        history.push(QueryString.append(path, params));
        trackerActions(
          mixpanelEventsEnum.ACTIONS_PARTNER.COGNITO_FORMS_ADMIN_SEARCH
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedQuery]);

  return (
    <Translation>
      {(t) => (
        <>
          <Title level={2} className='cognito-form-title'>
            {t('cognito_forms_admin_title')}
          </Title>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <Input
              size='large'
              style={{
                width: '20%',
              }}
              placeholder={t('cognito_form_admin_header_search')}
              allowClear
              onChange={(e) => onSearch(e)}
              value={search}
              maxLength={100}
            />
            <Button
              type='primary'
              size='large'
              icon={<PlusOutlined />}
              onClick={() => {
                trackerActions(
                  mixpanelEventsEnum.ACTIONS_PARTNER
                    .COGNITO_FORMS_ADMIN_ADD_SCREEN
                );
                showForm();
              }}
            >
              {t('cognito_form_admin_button_add_new_form')}
            </Button>
          </div>
        </>
      )}
    </Translation>
  );
};

export default withRouter(CognitoFormAdminHeaderScreen);

Logger.log('silly', `CognitoFormAdminHeaderScreen loaded.`);
